import { useEffect } from "react";
import { useHref, useLocation } from "react-router-dom";
import { getSelectedMenu } from "../../hooks/useSelectedMenu";

const pageContext = (pathname) => {
  const { parent, menu, subMenu } = getSelectedMenu(pathname) ?? {};
  return {
    ...(parent && { product: String(parent) }),
    ...(menu && { module: String(menu) }),
    ...(subMenu && { subModule: String(subMenu) }),
  };
};

// Every route change (the host and micro-frontends share one history) becomes
// a page view, labelled with the menu's product / module / sub-module.
const AnalyticsRouterSync = () => {
  const location = useLocation();
  const url = useHref(location.pathname);

  useEffect(() => {
    window.__ANALYTICS__?.setPage?.(url, pageContext(location.pathname));
  }, [url, location.pathname]);

  return null;
};

export default AnalyticsRouterSync;
